export default "__VITE_ASSET__CKj4tK8z__"